import React from 'react'
import PropTypes from 'prop-types'
import { Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'
import { cond, always, either, isNil, isEmpty, defaultTo } from 'ramda'
import withFieldError from 'components/form/with-error'
import { SelectPickerField } from 'components/form/selectpicker'

const selector = formValueSelector('widget')

export const FacebookCommentsOn = ({
  input: { value, onChange, ...input },
  meta: { error, touched }
}) => (
  <input
    {...input}
    className={'form-control ' + (error && touched ? 'has-error' : '')}
    type='text'
    placeholder='Enter post ID'
    defaultValue={value}
  />
)

FacebookCommentsOn.propTypes = {
  input: PropTypes.any,
  meta: PropTypes.any
}

export const FacebookCommentsOnWithError = withFieldError(FacebookCommentsOn)

export const validate = cond([
  [either(isEmpty, isNil), always('Please enter a Post ID')]
])

const FacebookCommentsOnField = ({ name }) => (
  <div>
    <Field
      name={`${name}.value`}
      component={FacebookCommentsOnWithError}
      validate={validate}
      format={defaultTo([])}
    />
  </div>
)

const TextMessageInput = ({ input, placeholder }) => (
  <div>
    <input
      className={'form-control right-element-no-borders '}
      type='text'
      placeholder={placeholder}
      {...input}
    />
  </div>
)

TextMessageInput.propTypes = {
  input: PropTypes.any,
  type: PropTypes.string,
  label: PropTypes.string,
  meta: PropTypes.any,
  placeholder: PropTypes.string
}

const TextMessageInputWithError = withFieldError(TextMessageInput)

export const FacebookInitialPostField = ({ name, selectedAction }) => (
  <div className='row select-group'>
    <div className='col-sm-4 br-no-pad-right component-select-picker'>
      <Field
        name={`${name}.action`}
        component={SelectPickerField}
        defaultValue='NEW_POST_TEXT'
      >
        <option value='NEW_POST_TEXT'>New Text Post</option>
        <option value='NEW_POST_IMAGE'>New Image Post</option>
        <option value='NEW_POST_VIDEO'>New Video Post</option>
        <option value='EXISTING_POST'>Existing Post</option>
      </Field>
    </div>
    <div className='col-sm-8 br-no-pad-left'>
      {selectedAction !== 'EXISTING_POST' && (
        <div className='br-has-checkbox col-sm-12'>
          <Field
            component={TextMessageInputWithError}
            label='Initial Post Text'
            name={`${name}.postText`}
            placeholder='Text for initial Facebook Post'
          />
        </div>
      )}
      {selectedAction === 'NEW_POST_IMAGE' && (
        <div className='br-has-checkbox col-sm-12'>
          <Field
            component={TextMessageInputWithError}
            label='Hosted Image URL'
            name={`${name}.imageUrl`}
            placeholder='Hosted Image URL'
          />
        </div>
      )}
      {selectedAction === 'NEW_POST_VIDEO' && (
        <div className='br-has-checkbox col-sm-12'>
          <Field
            component={TextMessageInputWithError}
            label='Hosted Video URL'
            name={`${name}.videoUrl`}
            placeholder='Hosted Video URL'
          />
        </div>
      )}
      {selectedAction === 'EXISTING_POST' && (
        <div className='br-has-checkbox col-sm-12'>
          <FacebookCommentsOnField name={name} />
        </div>
      )}
    </div>
  </div>
)

FacebookCommentsOnField.propTypes = {
  name: PropTypes.string
}

FacebookInitialPostField.propTypes = {
  name: PropTypes.string,
  selectedAction: PropTypes.string
}

const FacebookInitialPostWithType = connect((state, props) => ({
  selectedAction: selector(state, `${props.name}.action`)
}))(FacebookInitialPostField)

export default FacebookInitialPostWithType



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-triggers-actions/triggers/facebook/comments-on-post/index.js